import React from "react";
import secureLocalStorage from "react-secure-storage";
import { Navigate, Outlet } from "react-router-dom";
import Sidebar from "./Layouts/Sidebar";
import BirthdayAnimation from "./Screens/Home/BirthdayAnimation";

const PrivateComponent = () => {
  const [isChecking, setIsChecking] = React.useState(true);
  const [auth, setAuth] = React.useState(null);

  React.useEffect(() => {
    // Park any chat invite token from the URL BEFORE the auth redirect strips it.
    const params = new URLSearchParams(window.location.search);
    const inviteToken = params.get("chat_invite");
    if (inviteToken) {
      localStorage.setItem("planit_pending_chat_invite", inviteToken);
      window.history.replaceState({}, "", window.location.pathname);
    }

    const checkAuth = () => {
      const currentAuth = JSON.parse(secureLocalStorage.getItem("adminInfo"));
      setAuth(currentAuth);
      setIsChecking(false);
    };

    checkAuth();

    // Re-check auth whenever login writes new tokens — prevents the race where
    // navigate() fires before the Main remount (key change) completes.
    window.addEventListener("permissionsUpdated", checkAuth);
    return () => window.removeEventListener("permissionsUpdated", checkAuth);
  }, []);

  if (isChecking) {
    return null; // Or a simple spinner
  }

  return auth ? (
    <>
      <BirthdayAnimation />
      <Sidebar />
      {/* Screens are lazy-loaded in Main.jsx; the sidebar stays while one downloads */}
      <React.Suspense fallback={null}>
        <Outlet />
      </React.Suspense>
    </>
  ) : (
    <Navigate to="/" />
  );
};

export default PrivateComponent;
